import { useContext } from 'react';
import { AuthContent } from '../hoc/AuthProvider';

export function useAuth() {
  return useContext(AuthContent);
}
